<template>
  <Menu />
  <Zapis />
  <Phone />
  <div class="up">
    <Map />
  </div>
  <div class="cc">
    <div class="cont">
      <div class="mr"></div>
      <h1>
        Форма для отправки сообщений
      </h1>
      <form ref="form" @submit.prevent="sendEmail">    
        <input 
          required
          type="text" 
          placeholder="Имя"
          name="user_name"
        >
        <input 
          required
          type="number" 
          placeholder="Телефон"
          name="user_phone"
        >
        <textarea 
          type="text" 
          placeholder="Добавьте сообщение..."
          name="message"
        ></textarea>
       
         <label 
              for="sog"
            >
              Нажимая на кнопку «Отправить», вы даёте 
                <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FСогласие%20на%20обработку%20ПД%20на%20сайте.docx&name=Согласие%20на%20обработку%20ПД%20на%20сайте.docx&nosw=1" target="_blank" rel="noopener">
                  <h6>
                      согласие на обработку персональных данных
                  </h6>
                </a>
              на условиях, предусмотренных 
                <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПолитика%20обработки%20персональных%20данных%20на%20сайт.docx&name=Политика%20обработки%20персональных%20данных%20на%20сайт.docx&nosw=1" target="_blank" rel="noopener">
                    <h6>
                        политикой обработки персональных данных
                    </h6>
                </a>
            </label>
        <div class="bt">
        <input 
          class="bts"
          type="submit" 
          value="Отправить"
        >
        </div>
        <div class="vis" 
          v-show="visible"
        >
        <p>
          Ваше сообщение успешно отправлено! <br>
          Скоро мы Вам перезвоним.
        </p> 
        </div>  
      </form>
    </div>
  </div>
  <div class="fmr">
    <Foot />
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import Zapis from '@/components/Zapis.vue'
import Phone from '@/components/Phone.vue'
import Map from '@/components/Map.vue'
import Foot from '@/components/Foot.vue'
import emailjs from '@emailjs/browser';

export default {

name: 'ContactsView',
  components: {
    Menu,
    Zapis,
    Phone,
    Map,
    Foot,
  },
  data: () => ({     
    visible: false,   
  }),
  methods: {
    sendEmail(event) {
    emailjs.sendForm('service_n4vzwxo', 'template_u2cjc6a', this.$refs.form, '115yfGhv-PVucYBOw')
      .then((result) => {
      console.log('SUCCESS!', result.text);
      }, (error) => {
      console.log('FAILED...', error.text);
      });
      event.target.reset();
      this.visible = true;
      setTimeout(() => this.visible = false, 10000);
    }
  }
}
</script>

<style scoped>

.up {
  margin-top: -7.5vh;
}

.cc {
  background-color: #f5ee92;
  height: 100vh;
}

.mr {
  height: 5vh;
}

.cont {
  background-color: #f5ee92;
  width: 35vw;
  margin: 0 auto;
}

h1 {
  font-size: 2vw;
}

input {
  margin-top: 10px;
  border: #bb8745;
  width: 100%;
  height: 50px;
  padding: 20px;
}

textarea {
  margin-top: 10px;
  border: #bb8745;
  width: 100%;
  height: 100px;
  padding: 20px;
}

.check {
  width: 20px;
  margin: 0 0 0 0;
}

label {
  vertical-align: top;
  margin: 15px 20px;
  color: #333;
  font-size: 14px;
}

.bts {
  background: #bb8745;
  border: #bb8745;
  color: #fff;
  width: 100%;
  height: 50px;
  font-size: 20px;
  margin-top: 0;
  padding: 0;
}

.vis {
  margin-top: 20px;
  font-size: 1.2vw;
  color: green;
}

.btn {
  width: 100%;
  height: 50px;
  font-size: 20px;
}

h6 {
  font-size: 1.3vw;
  cursor: pointer;
  transition: all 0.4s ease;  
}

h6:hover {
  color: #bb8745;
  transition: all 0.4s ease;
}

@media (max-width: 790px) {

  .up {
    margin-top: 0;
  }

  .cc {
    margin-top: 20vh;
    min-height: 600px;
  }

  h1 {
    font-size: 20px;
  }

  .cont {
    width: 85vw;
  }

  .vis {
    font-size: 17px;
  }

  .fmr {
    margin-top: -20vh;
  }

  h6 {
    font-size: 14px;
  }

}

</style>